import axios from 'axios';

import { EmploymentAgency, PlanUnit } from 'components/types';

import { toLocalISOString } from 'utils/date';

import {
  COSTCENTERS,
  EMPLOYEE_COSTCENTERS,
  PUBLIC_COSTCENTERS
} from 'RestAPIs/endpoints';

type GetPlanUnitProps = {
  startDate: Date;
  endDate: Date;
  type?: 'public' | 'employee';
  filterByType?: 'cc' | 'agn' | 'rgp' | 'flex' | null;
};

export const getPlanUnits = ({
  startDate,
  endDate,
  type,
  filterByType
}: GetPlanUnitProps) => {
  return axios.get<PlanUnit[]>(
    `${
      type === 'employee'
        ? EMPLOYEE_COSTCENTERS
        : type === 'public'
        ? PUBLIC_COSTCENTERS
        : COSTCENTERS
    }`,
    {
      params: {
        startDate: toLocalISOString(startDate),
        endDate: toLocalISOString(endDate),
        name: '*',
        type: filterByType
      }
    }
  );
};

type GetEmploymentAgenciesProps = {
  startDate: Date;
  endDate: Date;
};

export const getEmploymentAgencies = ({
  startDate,
  endDate
}: GetEmploymentAgenciesProps) =>
  axios.get<EmploymentAgency[]>(COSTCENTERS, {
    params: {
      startDate: toLocalISOString(startDate),
      endDate: toLocalISOString(endDate),
      type: 'agn,rgp'
    }
  });
